export default {
  vendorBudget: {
    title: "Vendor-Budget Debug",
    buttons: {
      testIntegration: "Test Integration",
      testing: "Testing...",
      clear: "Clear",
    },
    errors: {
      noUserOrEvent: "❌ No user or event selected",
      noUser: "❌ No user connected",
      noEvent: "❌ No event selected",
      testError: "❌ Error during test",
    },
    messages: {
      startTest: "🧪 Complete vendor-budget integration test...",
      initialState: "📊 Initial expense state...",
      initialFound: "Initial: {{count}} expenses found",
      creatingVendor: "👨‍💼 Creating hired vendor with price...",
      vendorData: "Vendor data: {{data}}",
      vendorCreated: "✅ Vendor created with ID: {{id}}",
      waitingExpenses: "⏳ Waiting for expense creation...",
      checkingExpenses: "📊 Checking expenses after vendor creation...",
      afterCreation: "After creation: {{count}} expenses found",
      vendorExpenses: "Vendor expenses: {{count}}",
      expenseDetail: "{{index}}. {{title}}: {{amount}}€ (paid: {{paid}})",
      checkingIds: "🔍 Checking expense IDs in vendor...",
      vendorFound: "Vendor found: {{name}}",
      expenseId: "expenseId: {{id}}",
      depositExpenseId: "depositExpenseId: {{id}}",
      notDefined: "not defined",
      vendorNotFound: "❌ Vendor not found after creation",
      cleanup: "🧹 Cleanup: deleting test vendor...",
      vendorDeleted: "✅ Test vendor deleted",
      finalCheck: "📊 Final expense check...",
      finalCount: "Final: {{count}} expenses found",
      cleanupSuccess: "✅ Cleanup successful: all test expenses have been deleted",
      cleanupWarning: "⚠️ Warning: some test expenses might remain",
    },
    noLogs: "No logs yet...",
  },
  contactsApi: {
    title: "Contact Picker API Test",
    browser: "Browser",
    https: "HTTPS",
    apiStatus: "Contact Picker API",
    enabled: "Enabled",
    disabled: "Disabled",
    supported: "Supported",
    notSupported: "Not supported",
    technicalDetails: "Technical Details",
    userAgent: "User Agent",
    platform: "Platform",
    language: "Language",
    cookiesEnabled: "Cookies enabled",
    yes: "Yes",
    no: "No",
    testButton: "Test contact access",
    testing: "Testing...",
    error: "Error",
    contactsRetrieved: "Contacts retrieved ({{count}})",
    noName: "No name",
    recommendations: "Recommendations",
    recommendation1: "• Use Chrome on Android or Safari on iOS for best results",
    recommendation2: "• Make sure the site is on HTTPS",
    recommendation3: "• Allow contact access when prompted",
    recommendation4: "• This API only works on mobile in most cases",
    errors: {
      notSupported: "The Contact Picker API is not supported on this browser",
      unknown: "Unknown error accessing contacts",
    },
    browserDetection: {
      chromeMobile: "Chrome Mobile",
      safariMobile: "Safari Mobile",
      chromeDesktop: "Chrome Desktop",
      safariDesktop: "Safari Desktop",
      firefox: "Firefox",
      edge: "Edge",
      unknown: "Unknown Browser",
    },
  },
}; 